"use strict";
/**
 * @file Created on Thu Dec 12 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomáš Leity
 */


var DummyWindowSimulationSessionConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DummyWindowSimulationSessionConverter, _DataObjectConverter_);

  function DummyWindowSimulationSessionConverter() {
    _classCallCheck(this, DummyWindowSimulationSessionConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowSimulationSessionConverter).apply(this, arguments));
  }

  return DummyWindowSimulationSessionConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DummyWindowSimulationSessionConverter = DummyWindowSimulationSessionConverter;